import * as React from 'react';
import { usePersonDevicesOs } from '../hooks';
import { ActorApiStringDisplay } from '../../../../../components/display/string';

export const PersonsDevicesOS = () => {
  const {
    data,
    isLoading,
    error,
  } = usePersonDevicesOs();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
